import { useMaterials, useSelectedValueByVariableKey } from '@k3/core'
import { RoundedBox, Plane } from '@react-three/drei'
import { isEFormUnichromeType, Keys, MaterialNames } from '../utility/utils'
import { useDimensions } from './useDimensions'
import { Color } from 'three'
import { useEffect, useMemo, useState } from 'react'
import { SupportedMaterial } from '@k3/core/src/lib/types/material.interface'
import { loadMaterial } from '../utility/materialLoader'

export const FrontGlassPanel = () => {
  const [frontGlasMaterial, setFrontGlasMaterial] =
    useState<SupportedMaterial>()
  const [frontGlasFolieMaterial, setFrontGlasFolieMaterial] =
    useState<SupportedMaterial>()
  const materialList = useMaterials()
  const materials = useMemo(
    () => new Map(materialList.map((m) => [m.name, m])),
    [materialList]
  )

  const { length, width, thickness } = useDimensions()
  const productValue = useSelectedValueByVariableKey(Keys.EFormType.Variable)
  const color = useSelectedValueByVariableKey(Keys.FrontGlassColor.Variable)
  const surfaceRoughness = useSelectedValueByVariableKey(
    Keys.FrontGlassSurface.Variable
  )

  useEffect(() => {
    let name: string = MaterialNames.FrontGlass_Glossy
    if (surfaceRoughness?.key === Keys.FrontGlassSurface.Value.Matte) {
      name = MaterialNames.FrontGlass_Matt
    }
    if (materials.has(name)) {
      loadMaterial(materials.get(name)!, (mat) => {
        mat.depthWrite = false
        mat.envMapIntensity = 0.7
        setFrontGlasMaterial(mat)
      })
    } else {
      setFrontGlasMaterial(undefined)
    }
  }, [materials, surfaceRoughness])
  useEffect(() => {
    let name: string = MaterialNames.FrontGlasFolie_Glossy
    if (surfaceRoughness?.key === Keys.FrontGlassSurface.Value.Matte) {
      name = MaterialNames.FrontGlasFolie_Matt
    }
    if (materials.has(name)) {
      const m = materials.get(name)!
      loadMaterial(m, (mat) => {
        mat.color = new Color((color?.value as any) || 'grey')
        mat.depthWrite = false
        mat.envMapIntensity = 0.1
        setFrontGlasFolieMaterial(mat)
      })
    } else {
      setFrontGlasFolieMaterial(undefined)
    }
  }, [materials, color, surfaceRoughness])

  return (
    <>
      {isEFormUnichromeType(productValue) && frontGlasFolieMaterial && (
        <mesh
          position={[width / 2.0, length / 2.0, -0.0007]}
          castShadow={true}
          receiveShadow={false}
        >
          <Plane args={[width, length]} material={frontGlasFolieMaterial} />
        </mesh>
      )}

      {frontGlasMaterial && (
        <RoundedBox
          args={[width, length, thickness]}
          position={[width / 2.0, length / 2.0, -thickness / 2]}
          radius={0.0005}
          smoothness={0.5}
          material={frontGlasMaterial}
        ></RoundedBox>
      )}
    </>
  )
}
